import {
	Component,
	computed,
	inject,
	input,
	OnInit,
	Renderer2,
} from '@angular/core';

import { DynamicModule, InputsType } from 'ng-dynamic-component';

import { Components } from '@valk-nx/storyblok/components/reference/src/lib/reference.component';
import { StoryblokRootDirective } from '@valk-nx/storyblok-directives/src/lib/directives/storyblok-root.directive';
import { StoryblokHelper } from '@valk-nx/storyblok-helpers/src/lib/general/storyblok.helper';
import { MetadataService } from '@valk-nx/storyblok-services/src/lib/services/metadata.service';
import { ISbStoryBlok } from '@valk-nx/storyblok-types/src/lib/types/storyblok.types';

@Component({
	selector: 'sb-page',
	templateUrl: './page.component.html',
	imports: [DynamicModule],
})
export class PageComponent extends StoryblokRootDirective implements OnInit {
	private readonly metadataService = inject(MetadataService);
	private readonly renderer2 = inject(Renderer2);

	components: typeof Components = Components;

	readonly content = input.required<ISbStoryBlok[]>();
	readonly metaDescription = input.required<string>();
	readonly metaTitle = input.required<string>();

	contentInput = computed((): (InputsType & { component: string })[] => {
		return this.content().map((blok) => ({
			...blok,
			component: blok['component'] ?? '',
		}));
	});

	ngOnInit() {
		const faqs = StoryblokHelper.getAllAccordionItems(this.content());
		if (faqs.length > 0) {
			this.metadataService.setSchemaOrgFaq(
				this.renderer2,
				this.metaTitle(),
				this.metaDescription(),
				faqs,
			);
		}
	}
}
